export default __webpack_public_path__ + "static/covid-secure-logos-8074d79c2a467f7654f620d3a1bef649.png";